/* eslint-disable no-console */
import { register } from 'register-service-worker'

if (!('serviceWorker' in navigator)) {
  console.log('Service Worker not supported')
} else {
  console.log('Service Worker supported')
}

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log('SW ready() - App is being served from cache by a service worker.')
    },
    registered() {
      console.log('SW registered() - Service worker has been registered.')
    },
    cached() {
      console.log('SW cached() - Content has been cached for offline use.')
      window.dispatchEvent(new CustomEvent('pwa-update-cached'))
    },
    updatefound() {
      console.log('SW updatefound() - New content is downloading.')
      window.dispatchEvent(new CustomEvent('pwa-update-downloading'))
    },
    updated(registration) {
      console.log('SW updated() - New content is available.')
      if (registration.waiting) {
        window.dispatchEvent(new CustomEvent('pwa-update-ready', { 
          detail: registration 
        }))
      }
    },
    offline() {
      console.log('SW offline() - No internet connection found.')
    },
    error(error) {
      console.error('SW error() - Error during service worker registration:', error)
    }
  })
}
